<script>
    import Layout from '@layouts/main.vue'
    import Breadcrumb from '@/src/components/Breadcrumb.vue'
    import vuetableFormatters from '@src/mixins/vuetableFormatters'
    import swalFeedback from '@src/mixins/swalFeedback.vue'
    import multiSelectWithService from "@components/multiSelectWithService.vue"
    import FilesService from "@src/services/FilesService"
    import PageHeader from "@components/PageHeader.vue"
    import CancelButton from "@components/CancelButton.vue"
    import SaveButton from "@components/SaveButton.vue";
    import validation from "@src/mixins/validation.vue"
    import UsersService from '@src/services/UsersService'
    import PosService from '@src/services/PosService'
    import formatDate from "date-fns/format";
    import parseDate from "date-fns/parse";
    import { requiredIf, minLength } from 'vuelidate/lib/validators'
    import { debounce } from "lodash";
import JustificationService from '@/src/services/JustificationService'

    const i18nKey = 'WORKSCHEDULES'
    const i18nCommon = 'COMMON'

    const isTrueImage = (value, model) => {
        if (!value || !value.type) {
            return true
        }
        return value.type.startsWith('image')
    }

    const isSizeValid = (value, model) => {
        if (!value || !value.size) {
            return true
        }
        return value.size <= 1048576
    }

    export default {
        components: {
            SaveButton,
            CancelButton,
            PageHeader,
            multiSelectWithService,
            Layout,
            Breadcrumb,
        },
        mixins: [
            validation,
            swalFeedback,
            vuetableFormatters
        ],
        data() {
            return {
                selectedFiles: null,
                loading: false,
                fileError: null,
                submitLoading: false,
                sizeLargerThanAllowed: false,
                loadingUser: false,
                loadingPos: false,
                data: {
                    description: '',
                    photos: [],
                    justification: null,
                },
                i18nCommon,
                i18nKey,
                sortOrder: [
                    {
                        field: 'updated_at',
                        direction: 'desc',
                    },
                ],
                modal: {
                    id: null,
                    pos_id: null,
                    pos: {
                        id: 0,
                        name: '',
                    },
                    user_id: null,
                    user: {
                        id: 0,
                        name: '',
                    },
                },
                additionalParametersGrid: {
                    with: ['pointOfSale', 'pointOfSale.chain', 'user'],
                    user_id: [this.$route.params.id]
                },
                filtersCalendar: {
                    user_id: this.$route.params.id,
                },
                user: {},
                pointOfSale: {},
            }
        },
        validations:{
            data: {
                description: {
                    required: requiredIf(function () {
                        console.log(this.data);
                        return this.data.justification?.needs_text ?? false;
                    }),
                    minLength: minLength(15),
                },
                photos: {
                    isTrueImage,
                    isSizeValid,
                    validateMinFiles(value) {
                        if (this.data.justification?.needs_photo) {
                            return value?.length >= 1;
                        }

                        return true;
                    },
                    validateMaxFiles(value) {
                        if (this.data.justification?.needs_photo) {
                            return value?.length <= 1;
                        }

                        return true;
                    }
                }
            },
        },
        computed: {
            dataValid() {
                return !this.$v.data.$invalid
            },
            filterParameters() {
                return {
                    per_page: 1000,
                    page: 1,
                    orderBy: 'name',
                    sortedBy: 'asc',
                }
            },
            i18nJustify() {
                return this.getI18n(i18nKey,'TITLES.justify')
            },
            i18nJustification() {
                return this.getI18n('RELATIONS.TYPES.justification')
            },
            i18nDescription() {
                return this.getI18n(i18nCommon, 'description')
            },
            i18nDescriptionLength() {
                return this.getI18n('PLACEHOLDERS.description_length')
            },
            i18nBack() {
                return this.getI18n(i18nCommon, 'back')
            },
            i18nPhoto() {
                return this.getI18n('FILES.TITLES.file')
            },
            i18nUsers() {
                return this.getI18nModified({
                    prefix: 'USERS',
                    suffix: 'TITLES.user',
                    modifier: 2,
                })
            },
            i18nWorkSchedule() {
                return this.getI18nModified({
                    prefix: i18nKey,
                    suffix: 'TITLES.work_schedule',
                    modifier: 2,
                })
            },
            items() {
                return [
                    {
                        text: 'Home',
                        href: '/',
                    },
                    {
                        text: this.getI18nModified({
                            prefix: i18nKey,
                            suffix: 'TITLES.work_schedule',
                            modifier: 2,
                        }),
                        active: true,
                    },
                    {
                        text: this.getI18nModified({
                            prefix: 'USERS',
                            suffix: 'TITLES.user',
                            modifier: 2,
                        }),
                        href: '/workschedules'
                    },
                    {
                        text: this.getI18nModified({
                            prefix: i18nKey,
                            suffix: 'TITLES.work_schedule',
                            modifier: 2,
                        }),
                        href: '/workschedule/' + this.$route.params.id
                    },
                    {
                        text: this.getI18n(i18nKey,'TITLES.justify'),
                        active: true,
                    },
                ]
            },
        },
        watch: {
            filterText: debounce(function (searchText) {
                this.additionalParametersGrid = {
                    search: '',
                    with: ['pointOfSale', 'pointOfSale.chain', 'user'],
                }

                if (searchText && searchText.length > 0) {
                    this.additionalParametersGrid.search = `user.name:${searchText};pointOfSale.name:${searchText};`
                }
                this.refreshTable()
            }, 1000),
        },
        mounted() {
            this.loadingUser = true
            this.loadingPos = true
            UsersService
                .fetchById(this.$route.params.id)
                .then(response => {
                    this.user = response.data.data
                })
                .finally(() => {
                    this.loadingUser = false
                })
            PosService
                .fetchById(this.$route.params.pointOfSaleId)
                .then(response => {
                    this.pointOfSale = response.data.data
                })
                .finally(() => {
                    this.loadingPos = false
                })
        },
        methods: {
            replaceModalData(data) {
                Object.assign(this.modal, {
                    id: data.id,
                    pos_id: data.point_of_sale_id,
                    pos: data.pointOfSale,
                    user_id: data.user_id,
                    user: data.user,
                    priority_order: data.priority_order,
                    human_readable_frequencies: data.human_readable_frequency,
                })
            },
            createAdditionalParametersGrid() {
                return this.formatParameters({
                    with: ['pointOfSale', 'pointOfSale.chain', 'user'],
                    point_of_sale_id: this.filtersGrid.pos.map((pos) => pos.id),
                    frequency: this.filtersGrid.frequency,
                })
            },
            goToBack() {
                this.$router.push({
                    name: 'workScheduleForUser',
                })
            },
            // Função para retornar a mensagem de erro correta
            getFileInvalidMessage() {
                let errorMessage = "invalid_file";

                // Verifica o número mínimo de arquivos
                if (!this.$v.data.photos.validateMinFiles) {
                    errorMessage = 'invalid_min_files';
                }
                // Verifica o número máximo de arquivos
                else if (!this.$v.data.photos.validateMaxFiles) {
                    errorMessage = 'invalid_max_files';
                }
                // Verifica se o tamanho dos arquivos é válido
                else if (!this.$v.data.photos.isSizeValid) {
                    errorMessage = 'invalid_size_file';
                }

                // Retorna a mensagem de erro traduzida
                return this.$tc(this.makeI18nKey('ERROR_CODES', errorMessage));
            },
            async handleOk() {
                this.$v.data.$touch()

                if (this.submitLoading || !this.dataValid) {
                    return;
                }

                this.submitLoading = true;

                // const hash = null;
                let hash = crypto?.randomUUID();
                const photos = [];
                for (const photo of this.data.photos) {
                    const result = await FilesService.upload(
                        photo.file,
                        'justification_photos',
                        false
                    )

                    if (result.data.data.hash ?? null) {
                        hash = result.data.data.hash;
                        photos.push(result.data.data.hash);
                    }
                }

                const now = new Date();
                const questionnaireDate = parseDate(this.$route.params.date, 'yyyy-MM-dd', new Date());
                questionnaireDate.setHours(now.getHours())
                questionnaireDate.setMinutes(now.getMinutes())
                questionnaireDate.setSeconds(now.getSeconds())
                const date = formatDate(questionnaireDate, "yyyy-MM-dd HH:mm:ss");
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

                let justification = '-';
                if (this.data.justification?.needs_text) {
                    justification = this.data.description ?? '-';
                }

                await JustificationService.create({
                    justification,
                    hash: hash,
                    justification_type_id: this.data.justification.id,
                    point_of_sale_id: this.$route.params.pointOfSaleId,
                    work_schedule_id: this.$route.params.workScheduleId,
                    user_id: this.$route.params.id,
                    justification_date: date,
                    justification_timezone: timezone,
                }).then(result => {
                    this.successFeedback('Justificar', 'Justificativa enviada com sucesso');
                    this.reset();
                    this.submitLoading = false;
                })
            },
            handleDescriptions() {
                this.$v.modal.$touch()
            },
            hideModal() {
                this.$refs.modal.hide()
            },
            reset() {
                this.$nextTick(() => this.$v.$reset())
                this.clearAllResponseError()
                this.loading = false;
                this.submitLoading = false;
                this.sizeLargerThanAllowed = false;
                this.data = {
                    photos: null,
                    justification: null,
                }
            },
            onFileChange(event) {
                const files = event.target.files;
                this.fileError = null;

                for (let i = 0; i < files.length; i++) {
                    if (this.data.photos.length >= this.data.justification?.justification?.max_files ?? 0) {
                        this.fileError = this.$tc(this.makeI18nKey('ERROR_CODES', 'invalid_max_files'));
                        break;
                    }

                    const file = files[i];
                    const imageUrl = URL.createObjectURL(file);

                    this.data.photos.push({ file, url: imageUrl });

                    this.$v.data.photos.$touch();

                    if (this.$v.data.photos.$invalid) {
                        this.fileError = this.getFileInvalidMessage();
                        break;
                    }
                }

                event.target.value = '';
            },
            removeImage(index) {
                this.fileError = null;

                this.data.photos.splice(index, 1);
                this.$v.data.photos.$touch();

                if (this.$v.data.photos.$invalid) {
                    this.fileError = this.getFileInvalidMessage();
                }

                // Limpa o valor do input file
                if (this.$refs.logoFile) {
                    this.$refs.logoFile.reset();
                }
            }
        },
        metaInfo() {
            return {
                title: this.getI18nModified({
                    prefix: i18nKey,
                    suffix: 'TITLES.work_schedule',
                    modifier: 2,
                }),
            }
        },
    }
</script>

<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="items" />
            <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                    <b-skeleton v-if="loadingUser" type="text" width="35%" class="mt-1"/>
                    <h2 v-else class="mb-0">{{user.name}}</h2>
                    <b-skeleton v-if="loadingPos" type="text" width="25%" class="mt-2"/>
                    <h4 v-else class="mb-0 text-muted">{{pointOfSale.name}}</h4>
                </div>
                <b-button class="btn btn-pdv-gradient-blue-transparent" size="sm" @click="goToBack">
                    <i class="fe-corner-up-left"></i>
                    {{ i18nBack }}
                </b-button>
            </div>

            <PageHeader :title="`${i18nJustify} ${i18nWorkSchedule}`" />
            <form @submit.prevent="handleOk">
                <b-form-row>
                    <b-col md="12">
                        <!-- Justificativa -->
                        <b-form-row>
                            <b-col md="4">
                                <b-form-group
                                    class="label-pdv"
                                    :label="i18nJustification"
                                    label-for="justification"
                                    :invalid-feedback="
                                        getI18n(
                                            'ERROR_CODES.invalid_justification'
                                        )
                                    "
                                >
                                    <multiSelectWithService
                                        :id="'justification-type'"
                                        ref="parentJustificationSelect"
                                        v-model="data.justification"
                                        :service="'justification-types'"
                                        label="name"
                                        :searchable="true"
                                        :multiple="false"
                                        :parameters="filterParameters"
                                    ></multiSelectWithService>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <!-- Descrição -->
                        <b-form-row v-if="data.justification && data.justification.needs_text">
                            <b-col md="4">
                                <b-form-group
                                    class="label-pdv"
                                    :label="i18nDescription"
                                    label-for="description"
                                    :invalid-feedback="getI18n('ERROR_CODES.invalid_reason_length')"
                                >
                                    <b-form-textarea
                                        id="description"
                                        v-model.trim="$v.data.description.$model"
                                        class="input-pdv-blue"
                                        rows="6"
                                        max-rows="6"
                                        autofocus
                                        autocomplete="off"
                                        :disabled="submitLoading"
                                        :placeholder="i18nDescriptionLength"
                                        :state="validateField('description', 'data')"
                                        @input="clearResponseError('description', 'data')"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <!-- Foto -->
                        <b-form-row v-if="data.justification && data.justification.needs_photo">
                            <b-col md="12">
                                <b-form-group
                                    label-for="logoFile"
                                    :label="i18nPhoto"
                                    :invalid-feedback="fileError"
                                    class="w-100"
                                >
                                    <div class="image-preview-container">
                                        <label for="logoFile" class="custom-file-upload">
                                            <i class="fe-upload-cloud"></i>
                                            <span>Selecionar arquivos</span>
                                        </label>
                                        <input
                                            id="logoFile"
                                            ref="logoFile"
                                            type="file"
                                            accept=".jpg"
                                            class="d-none"
                                            @change="onFileChange"
                                        />

                                        <!-- Exibir as miniaturas das imagens -->
                                        <div v-for="(image, index) in data.photos" :key="index" class="image-preview">
                                            <img :src="image.url" alt="Miniatura da imagem" class="img-thumbnail" />
                                            <button
                                                type="button"
                                                class="btn btn-danger btn-sm image-remove"
                                                @click="removeImage(index)"
                                            >
                                                X
                                            </button>
                                        </div>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-form-row>
            </form>
            <b-form-row>
                <b-col md="6">
                    <save-button
                        ref="okButton"
                        :busy="submitLoading"
                        :disabled="submitLoading || !dataValid"
                        :title="getI18n('ACTION.save')"
                        @onClick="handleOk"
                    />
                </b-col>
                <b-col md="6">
                    <cancel-button
                        ref="cancelButton"
                        child-class="float-left"
                        @onClick="goToBack"
                    />
                </b-col>
            </b-form-row>
        </div>
    </Layout>
</template>

<style>
    .text-danger {
        margin-bottom: 1rem;
        font-weight: bold;
        color: red;
    }
    .image-upload-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .image-preview-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: flex-start;
    }
    .custom-file-upload {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 130px;
        height: 100px;
        cursor: pointer;
        background-color: #f8f9fa;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: background-color 0.2s;
    }
    .custom-file-upload:hover {
        background-color: #e9ecef;
    }
    .custom-file-upload i {
        margin-bottom: 5px;
        font-size: 24px;
        color: #6c757d;
    }
    .custom-file-upload span {
        font-size: 12px;
        color: #6c757d;
    }
    .image-preview {
        position: relative;
        flex-shrink: 0;
        width: 130px;
        height: 100px;
    }
    .img-thumbnail {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .image-remove {
        position: absolute;
        top: 5px;
        right: 5px;
        padding: 0 6px;
    }
</style>
